import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { GlobalNotificationsPanelProps } from './types';

type GlobalNotificationsPanelEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	GlobalNotificationsPanelProps,
	Record<string, never>
>;

/**
 * Shared entry point for the global notifications panel.
 *
 * The panel owns no eager queries yet. The notification list starts its feed
 * request after this interaction-loaded component mounts.
 */
export const globalNotificationsPanelEntryPoint: EntryPoint<
	GlobalNotificationsPanelEntryPointComponent,
	Record<string, never>
> = createEntryPoint({
	root: JSResourceForInteraction<GlobalNotificationsPanelEntryPointComponent>(() => import(/* webpackChunkName: "@atlaskit-internal_@atlassian/notification-list/GlobalNotificationsPanel" */ "./GlobalNotificationsPanel.tsx"), { moduleId: "3aa0e9a7", moduleName: "GlobalNotificationsPanel", modulePath: "../platform/packages/notifications/notification-list/src/ui/global-notifications-panel/GlobalNotificationsPanel.tsx", priority: "interaction", moduleId: 'global-notifications-panel-entrypoint' }),
	getPreloadProps: () => ({}),
});
